import styled from 'styled-components';

export const BattleNowContent = styled.div`
  position: relative;
  width: 24rem;
  height: 24rem;
`;

export const BattleNowLogoWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const BattleNowBackground = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const BattleNowLogo = styled.div`
  position: relative;
  height: 5rem;
  width: 80%;
`
export const Fight = styled.img`
  position: absolute;
  width: 100%;
`;

export const Prepare = styled.img`
  position: absolute;
  width: 100%;
  top: 50%;
`;

export const Caption = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 1rem;
  width: 60%;
  background: ${({ theme }) => theme.buttonDark};
  font-family: "NeueMachina";
  font-size: 1rem;
  font-weight: 400;
  color: white;
  height: 4rem;
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.inputBorder};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-transform: uppercase;

  .decorator {
    width: 100%;
    height: ${({ theme }) => theme.frameWidth};
    background: ${({ theme }) => theme.buttonGreen};
  }
`;

export const CaptionText = styled.div`
  width: auto;
  font-weight: 600;
  padding: 0.5rem 1rem;
  flex: 1;
  text-align: center;
`;
